ViewerCreate:
  parameters:
    - $ref: "../parameters.yaml#/HeaderAccessToken"

  post:
    operationId: postViewerCreate
    tags:
      - Viewer
    summary: ファイルビューアの作成
    description: |
      ### ファイルビューアを作成します。

    security:
      - AccessToken: [ ]

    requestBody:
      $ref: "../openapi/requests.yaml#/CreateViewerRequest"

    responses:
      "200":
        description: ファイルビューア作成成功
        content:
          application/json:
            schema:
              $ref: "../openapi/responses.yaml#/ViewerLink"
      "default":
        description: ファイルビューア作成失敗
        content:
          application/json:
            examples:
              SessionTimeout:
                $ref: "../openapi/response.error.yaml#/SessionTimeout"
              Invalid Input:
                $ref: "../openapi/response.error.yaml#/InvalidInput"
              Do Not Have Permission:
                $ref: "../openapi/response.error.yaml#/DoNotHavePermissionfilev"
              Preview Not Support File Type:
                $ref: "../openapi/response.error.yaml#/PreviewNotSupportFileType"